module.exports = __webpack_public_path__ + "static/media/git.4675c40a.svg";